interface EnvironmentVariables {
    REACT_APP_API_URL: string;
    REACT_APP_BLOB_URL: string;
    REACT_APP_PRESENT_TARGETS_TIME: string;
    REACT_APP_CUED_RECALL_TIME: string;
    REACT_APP_FREE_RECALL_TIME: string;
    REACT_APP_FREE_RECALL_TIMEOUT: string;
    REACT_APP_DELAY_TIME: string;
    REACT_APP_ASSESSMENT_TIMEOUT: string;
    REACT_APP_SHOW_TIMERS: string;
    REACT_APP_SHOW_LOGS: string;
    REACT_APP_STT_BOOST: string;
    REACT_APP_STT_PT_TIMEOUT: string;
    REACT_APP_STT_FR_TIMEOUT: string;
    REACT_APP_STT_CR_TIMEOUT: string;
    REACT_APP_GOOGLE_STT_KEY: string;
    REACT_APP_AZURE_STT_KEY: string;
    REACT_APP_AZURE_STT_REGION: string;
    REACT_APP_B2C_CLIENT_ID: string;
    REACT_APP_B2C_DOMAIN: string;
    REACT_APP_B2C_SIGNIN: string;
    REACT_APP_B2C_FORGOTPASS: string;
    REACT_APP_B2C_AUTHORITY_SIGNIN: string;
    REACT_APP_B2C_AUTHORITY_FORGOTPASS: string;
    REACT_APP_B2C_AUTHORITY_DOMAIN: string;
    REACT_APP_STRIPE_PUBLISHABLE_KEY: string;
    REACT_APP_APPINSIGHTS_KEY: string;
}

export const Env: EnvironmentVariables = {
    REACT_APP_API_URL: process.env.REACT_APP_API_URL!,
    REACT_APP_BLOB_URL: process.env.REACT_APP_BLOB_URL!,
    REACT_APP_PRESENT_TARGETS_TIME: process.env.REACT_APP_PRESENT_TARGETS_TIME!,
    REACT_APP_CUED_RECALL_TIME: process.env.REACT_APP_CUED_RECALL_TIME!,
    REACT_APP_FREE_RECALL_TIME: process.env.REACT_APP_FREE_RECALL_TIME!,
    REACT_APP_FREE_RECALL_TIMEOUT: process.env.REACT_APP_FREE_RECALL_TIMEOUT!,
    REACT_APP_DELAY_TIME: process.env.REACT_APP_DELAY_TIME!,
    REACT_APP_ASSESSMENT_TIMEOUT: process.env.REACT_APP_ASSESSMENT_TIMEOUT!,
    REACT_APP_SHOW_TIMERS: process.env.REACT_APP_SHOW_TIMERS!,
    REACT_APP_SHOW_LOGS: process.env.REACT_APP_SHOW_TIMERS!,
    REACT_APP_STT_BOOST: process.env.REACT_APP_STT_BOOST!,
    REACT_APP_STT_PT_TIMEOUT: process.env.REACT_APP_STT_PT_TIMEOUT!,
    REACT_APP_STT_FR_TIMEOUT: process.env.REACT_APP_STT_FR_TIMEOUT!,
    REACT_APP_STT_CR_TIMEOUT: process.env.REACT_APP_STT_CR_TIMEOUT!,
    REACT_APP_GOOGLE_STT_KEY: process.env.REACT_APP_GOOGLE_STT_KEY!,
    REACT_APP_AZURE_STT_KEY: process.env.REACT_APP_AZURE_STT_KEY!,
    REACT_APP_AZURE_STT_REGION: process.env.REACT_APP_AZURE_STT_REGION!,
    REACT_APP_B2C_CLIENT_ID: process.env.REACT_APP_B2C_CLIENT_ID!,
    REACT_APP_B2C_DOMAIN: process.env.REACT_APP_B2C_DOMAIN!,
    REACT_APP_B2C_SIGNIN: process.env.REACT_APP_B2C_SIGNIN!,
    REACT_APP_B2C_FORGOTPASS: process.env.REACT_APP_B2C_FORGOTPASS!,
    REACT_APP_B2C_AUTHORITY_SIGNIN: process.env.REACT_APP_B2C_AUTHORITY_SIGNIN!,
    REACT_APP_B2C_AUTHORITY_FORGOTPASS: process.env.REACT_APP_B2C_AUTHORITY_FORGOTPASS!,
    REACT_APP_B2C_AUTHORITY_DOMAIN: process.env.REACT_APP_B2C_AUTHORITY_DOMAIN!,
    REACT_APP_STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!,
    REACT_APP_APPINSIGHTS_KEY: process.env.REACT_APP_APPINSIGHTS_KEY!
};
